import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs/Rx';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class ContextService {

  public context: string;

  constructor (
  	private route: ActivatedRoute,
  ) { }

  isContextSet(): boolean{
  	if(sessionStorage.getItem('context_hachette_kne') === null){
  		return false;
  	} else {
  		return true;
  	}
  }

  getContext(): string{
    let cont=sessionStorage.getItem('context_hachette_kne');
  	return this.context =(cont==undefined)?"B2B":cont ;
  }


  setContext(value: string){
  	this.context = value;
  	sessionStorage.setItem('context_hachette_kne', this.context);
  }

  // onContextChange(url: string){
  //   let cont = this.getContext();
  //   if( cont == 'B2C' ){

  //   } else {
      
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/context.service.ts